import { Singleton } from 'framework/di';

import { AppService } from '../modules/app/app.service';

@Singleton()
export class ShopifyMarketHelper {
  constructor(protected appService: AppService) {}

  restrictMainCurrency(currencyInfo: CurrencyInfo) {
    const { money_format, money_format_with_currency, currency } = currencyInfo;

    if (money_format) {
      this.appService.TAEApp.updateConfig({
        shop: {
          money_format,
        },
      });
    }

    if (money_format_with_currency) {
      this.appService.TAEApp.updateConfig({
        shop: {
          money_format_with_currency,
        },
      });
    }

    if (currency) {
      this.appService.TAEApp.updateConfig({
        shop: {
          currency,
        },
      });
    }
  }
}

export type CurrencyInfo = {
  /**
   * The format for displaying money.
   */
  money_format: string;
  /**
   * The format for displaying money with currency.
   */
  money_format_with_currency: string;
  /**
   * The currency code.
   */
  currency: string;
};
